import { render } from "./seoInsights.vue?vue&type=template&id=632c7c5a"
import script from "./seoInsights.vue?vue&type=script&lang=js"
export * from "./seoInsights.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrew/Documents/Code/SeoBiz/AdminApp/FrontEnd/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__